import api from "./core";

const basePath = "api/core/Avatars";

const BaseURL = require("./serverCfg").default.coreBaseUrl;

export default {
  async downloadUrl(id) {
    const result = await api.get(
      `${basePath}/Download/${api.getToken()}/${id}`,
      {
        "Hide-Loading": true
      }
    );
    return result;
  },
  avatarUrl(id) {
    return `${BaseURL}${basePath}/DownloadAvatar/${api.getToken()}/${id}`;
  }
};
